var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 14,
    viewBox: "0 0 5 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 11.7143C1.2002 12.0553 1.34769 12.3823 1.61025 12.6234C1.8728 12.8645 2.22889 13 2.6002 13C2.9715 13 3.32759 12.8645 3.59014 12.6234C3.85269 12.3823 4.0002 12.0553 4.0002 11.7143C4.0002 11.3733 3.85269 11.0463 3.59014 10.8051C3.32759 10.564 2.9715 10.4286 2.6002 10.4286C2.22889 10.4286 1.8728 10.564 1.61025 10.8051C1.34769 11.0463 1.2002 11.3733 1.2002 11.7143ZM1.9002 8.71429H3.3002C3.42853 8.71429 3.53353 8.61786 3.53353 8.5V1.21429C3.53353 1.09643 3.42853 1 3.3002 1H1.9002C1.77186 1 1.66686 1.09643 1.66686 1.21429V8.5C1.66686 8.61786 1.77186 8.71429 1.9002 8.71429Z",
    fill: "#E43E4C",
    stroke: "#E43E4C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical);
export default __webpack_public_path__ + "static/media/critical.b57aa9c1.svg";
export { ForwardRef as ReactComponent };